import type { DatePreset, DateRange } from '../types'

export const QUEUE_DASHBOARD_ENDPOINTS = {
  OVERVIEW: '/api/queue-dashboard',
  HOURLY: '/api/queue-dashboard/hourly',
  LOCATIONS: '/api/queue-dashboard/locations',
  PRODUCTS: '/api/queue-dashboard/products',
  FACTORIES: '/api/queue-dashboard/factories',
  DAILY_TREND: '/api/queue-dashboard/daily-trend',
  WEIGHBRIDGE: '/api/queue-dashboard/weighbridge',
  STUCK_ORDERS: '/api/queue-dashboard/stuck-orders',
} as const

export const DEFAULT_DATE_RANGE: DateRange = {
  preset: 'this_week',
  from: null,
  to: null,
}

export const DATE_PRESETS: Record<DatePreset, { labelKey: string }> = {
  today: { labelKey: 'queueDashboard.dateRange.today' },
  yesterday: { labelKey: 'queueDashboard.dateRange.yesterday' },
  this_week: { labelKey: 'queueDashboard.dateRange.thisWeek' },
  last_week: { labelKey: 'queueDashboard.dateRange.lastWeek' },
  this_month: { labelKey: 'queueDashboard.dateRange.thisMonth' },
  last_month: { labelKey: 'queueDashboard.dateRange.lastMonth' },
  last_30_days: { labelKey: 'queueDashboard.dateRange.last30Days' },
  custom: { labelKey: 'queueDashboard.dateRange.custom' },
}
